/* eslint-disable no-restricted-imports */
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import relativeTime from 'dayjs/plugin/relativeTime';
/* eslint-enable */

dayjs.extend(isSameOrBefore);
dayjs.extend(relativeTime);

dayjs.locale('pt-br');

export default dayjs;
